export const createEstimateTypeSlice = (set, get) => ({
  // Selected estimate type: 'on_site_estimate' or 'on_site_estimate_and_perform_services'
  // Default to 'on_site_estimate_and_perform_services'
  selectedEstimateType: 'on_site_estimate_and_perform_services',

  // Track if user has manually selected an estimate type
  estimateTypeManuallySelected: false,

  // Set the estimate type
  setEstimateType: (type, isManual = false) => {
    set({
      selectedEstimateType: type,
      estimateTypeManuallySelected: isManual ? true : get().estimateTypeManuallySelected
    });
  },

  // Clear estimate type
  clearEstimateType: () => {
    set({
      selectedEstimateType: 'on_site_estimate_and_perform_services',
      estimateTypeManuallySelected: false
    });
  },
});
